<template>
  <v-app-bar app :flat="true" :height="80" color="#000">
    <v-row justify="center" align="center">
      <v-row style="max-width: 1280px;">
        <v-col cols="12" md="1">
          <v-row justify="center" align="center">
            <v-img :src="imgSrc" max-width="45"></v-img>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
  </v-app-bar>
</template>
<style>
  .logo-div {
    border-width: 0px;
    position: absolute;
    left: 25px;
    top: 5px;
    width: 120px;
    height: 40px;
  }
</style>
<script>
  export default {
    name: 'account-head',
    data() {
      return {
        title: this.$vuetify.lang.t('$vuetify.custom.title'), //"易途基础架构",
        imgSrc: require('../../../static/img/logo.png')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/account/account-head.vue